import { h, Fragment } from "@stencil/core";

export const Input = (props: {
  type: string;
  label: string;
  key: string;
  value: string | number;
  onChange: (e: any) => void;
  min?: number;
  max?: number;
  required?: boolean;
  readonly: boolean;
  style?: { [key: string]: string };
}) => {
  return (
    <Fragment>
      <label htmlFor={props.key}>{props.label}</label>
      <input
        style={props.style}
        autocomplete="off"
        type={props.type}
        id={props.key}
        name={props.key}
        min={props.min}
        max={props.max}
        required={props.required}
        value={props.value}
        readOnly={props.readonly}
        onChange={props.onChange}
      />
    </Fragment>
  );
};
